// ====================================
// MentorMatching.jsx
// ====================================
import React, { useState } from 'react';
import Button from '@/components/ui/Button';
import Icon from '@/components/AppIcon';
import apiRequest from '@/services/requests';

const MentorMatching = ({ mentors, targetRole, transitionPlanId, onClose }) => {
const [requesting, setRequesting] = useState(null);

const handleRequestMentor = async (mentorId) => {
setRequesting(mentorId);
try {
await apiRequest.requestMentorship({
mentorId,
transitionPlanId,
topics: [`Career transition to ${targetRole?.title}`],
notes: 'Initial mentorship request'
});
alert('Mentorship request sent successfully!');
onClose();
} catch (error) {
console.error('Error requesting mentor:', error);
alert('Failed to send request');
} finally {
setRequesting(null);
}
};

return (
<div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
<div className="bg-card border border-border rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
<div className="p-6">
<div className="flex items-center justify-between mb-6">
<h2 className="text-2xl font-bold text-text-primary">Find Your Mentor</h2>
<button onClick={onClose} className="text-text-secondary hover:text-text-primary">
<Icon name="X" size={24} />
</button>
</div>

<div className="grid grid-cols-1 md:grid-cols-2 gap-6">
{mentors?.map(mentor => (
<div key={mentor.id} className="border border-border rounded-lg p-4">
<div className="flex items-start space-x-4 mb-4">
<div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center">
<Icon name="User" size={24} className="text-primary" />
</div>
<div className="flex-1">
<h3 className="text-lg font-semibold text-text-primary">{mentor.name}</h3>
<p className="text-sm text-text-secondary">{mentor.currentRole}</p>
<p className="text-xs text-text-secondary">{mentor.company}</p>
</div>
<div className="flex items-center space-x-1">
<Icon name="Star" size={14} className="text-warning fill-warning" />
<span className="text-sm font-medium text-text-primary">{mentor.rating}</span>
</div>
</div>

{mentor.transitionStory && (
<p className="text-sm text-text-secondary mb-3">{mentor.transitionStory}</p>
)}

<div className="flex flex-wrap gap-2 mb-3">
{mentor.expertise?.slice(0, 3).map(exp => (
<span key={exp} className="bg-primary/10 text-primary text-xs px-2 py-1 rounded-full">
{exp}
</span>
))}
</div>

<div className="flex items-center justify-between text-xs text-text-secondary mb-4">
<span>{mentor.totalSessions || 0} sessions</span>
<span className={`px-2 py-1 rounded-full ${
mentor.availability === 'available' ? 'bg-success/10 text-success' : 'bg-warning/10 text-warning'
}`}>
{mentor.availability}
</span>
</div>

{mentor.recommendationReason && (
<p className="text-xs text-text-secondary mb-3 italic">
"{mentor.recommendationReason}"
</p>
)}

<Button
className="w-full"
size="sm"
onClick={() => handleRequestMentor(mentor.id)}
disabled={requesting === mentor.id || mentor.availability === 'unavailable'}
>
{requesting === mentor.id ? 'Requesting...' : 'Request Mentorship'}
</Button>
</div>
))}
</div>

{(!mentors || mentors.length === 0) && (
<div className="text-center py-12">
<p className="text-text-secondary">No mentors available at this time.</p>
</div>
)}
</div>
</div>
</div>
);
};

export default MentorMatching;